import { FormCard } from '@portal_components/components/FormCard';
import { FormRadioButtonGroup } from '@portal_components/components/FormRadioButtonGroup';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { BulkAssignListForm } from '../../types';

interface BulkAssignContactDetailsTabProps {
  index: number;
}

export const BulkAssignContactDetailsTab = ({ index }: BulkAssignContactDetailsTabProps) => {
  return (
    <FormCard>
      <FormTextInput<BulkAssignListForm> title="Site Contact Title" name={`siteList.${index}.contact.siteContactTitle`} mandatory />
      <FormTextInput<BulkAssignListForm> title="Site Contact First Name" name={`siteList.${index}.contact.siteContactFirstname`} />
      <FormTextInput<BulkAssignListForm> title="Site Contact Surname" name={`siteList.${index}.contact.siteContactSurname`} mandatory />
      <FormTextInput<BulkAssignListForm> title="Site Contact Number" name={`siteList.${index}.contact.siteContactNumber`} mandatory />
      <FormTextInput<BulkAssignListForm> title="Site Contact Extension" name={`siteList.${index}.contact.siteContactExtensionNumber`} />
      <FormTextInput<BulkAssignListForm> title="Site Contact Email" name={`siteList.${index}.contact.emailAddress`} />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Preferred Contact Method"
        name={`siteList.${index}.contact.preferredContactMethod`}
        buttons={[
          { title: 'Phone', value: 'Phone' },
          { title: 'Email', value: 'Email' }
        ]}
      />
      <FormTextInput<BulkAssignListForm> title="Site Contact Mobile Number" name={`siteList.${index}.contact.mobileNumber`} />
      <FormTextInput<BulkAssignListForm> title="Site Contact Fax Number" name={`siteList.${index}.contact.faxNumber`} />
    </FormCard>
  );
};
